module.exports = __webpack_public_path__ + "static/img/4.2855949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/4.png
// module id = FjOc
// module chunks = 0